import React, { useState, useEffect, useMemo } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { fetchAllPages } from "../../common/tableData";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Dummy from "../../assets/images/No_Image_Available.jpg";
import OrganizationChart from "components/Modal Org/OrganizationChart";

const DatatableTables = ({ t }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOrgChartOpen, setIsOrgChartOpen] = useState(false);
  const [selectedOrgId, setSelectedOrgId] = useState(null);

  const getCategoriesData = async () => {
    setIsLoading(true);
    try {
      const categories = await fetchAllPages(
        (page, pageSize) =>
          `category/categories/?page=${page}&page_size=${pageSize}&parent_id_isnull=true`
      );
      setRows(categories);
    } catch (error) {
      console.error("Error fetching category data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCategoriesData();
  }, []);

  const handleEdit = (id) => {
    navigate(`/category/edit/${id}`);
  };

  const handleExercises = (id) => {
    navigate(`/category/sub-category/${id}`);
  };

  const handleViewOrgChart = (id) => {
    setSelectedOrgId(id);
    setIsOrgChartOpen(true);
  };

  const tableData = useMemo(
    () => ({
      columns: [
        {
          label: t("ID"),
          field: "id",
          sort: "asc",
          width: 100,
        },
        {
          label: t("Image"),
          field: "image",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
        {
          label: t("Name"),
          field: "name",
          sort: "asc",
          width: 150,
        },
        {
          label: t("Status"),
          field: "is_active",
          sort: "asc",
          width: 270,
        },
        {
          label: t("Subcategory"),
          field: "subCategory",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
        {
          label: t("View Org Chart"),
          field: "viewOrgChart",
          sort: "disabled",
          searchable: false,
          width: 150,
        },
        {
          label: t("Action"),
          field: "edit",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
        
      ],
      rows: rows.map((row) => ({
        ...row,
        image: <img src={row.image || Dummy} alt="Category" width="50" height="50" />,
        edit: <Button color="primary" onClick={() => handleEdit(row.id)}>{t("Edit")}</Button>,
        subCategory: <Button color="primary" onClick={() => handleExercises(row.id)}>{t("Pain Area Body Parts")}</Button>,
        is_active: row.is_active ? t("True") : t("False"),
        viewOrgChart: <Button color="info" onClick={() => handleViewOrgChart(row.id)}>{t("View Org Chart")}</Button>,
      })),
    }),
    [rows, t]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle={t("Home")} title={t("Data")} breadcrumbItem={t("Pain Area's")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <CardTitle className="h4">{t("Pain Area's of body.")}</CardTitle>
                    <Button color="primary" onClick={() => navigate(`/category/create-category`)}>
                      <i className="typcn typcn-plus"></i> {t("Create New Pain Area")}
                    </Button>
                  </div>

                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging
                    searching
                    sortable
                    order={["id", "asc"]}
                    entries={10}
                    entriesOptions={[10, 25, 50, 100]}
                    displayEntries
                    info
                    infoLabel={[t("Showing"), t("to"), t("of"), t("entries")]}
                    paginationLabel={["<", ">"]}
                    searchLabel={t("Search")}
                    noRecordsFoundLabel={t(isLoading ? "Loading..." : "No records found")}
                    data={tableData}
                    className="custom-cursor-pointer"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <OrganizationChart isOpen={isOrgChartOpen} onClose={() => setIsOrgChartOpen(false)} orgId={selectedOrgId} />
    </React.Fragment>
  );
};

export default withTranslation()(DatatableTables);
